import { render, staticRenderFns } from "./WorkPlaceEmployees.vue?vue&type=template&id=613bfe2e&scoped=true&"
import script from "./WorkPlaceEmployees.vue?vue&type=script&lang=js&"
export * from "./WorkPlaceEmployees.vue?vue&type=script&lang=js&"
import style0 from "./WorkPlaceEmployees.vue?vue&type=style&index=0&id=613bfe2e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "613bfe2e",
  null
  
)

export default component.exports